// Function to generate and assign unique IDs to elements matching a selector
function generateUniqueIDs(selector) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element, index) => {
    //console.log("Element before:", element, "ID:", element.id, "Value:", element.value);

    // Declare the unique ID we will generate
    let uniqueID;

    // Use crypto.randomUUID if available 
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      uniqueID = crypto.randomUUID();
    } 
    // Use crypto.getRandomValues as a fallback
    else if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      // Fallback using crypto.getRandomValues for UUID generation
      uniqueID = 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (crypto.getRandomValues(new Uint8Array(1))[0] % 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
    } 
    // Just generate a random number on old browsers with the date
    else {
      // Final fallback using timestamp and random number
      uniqueID = `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    }

    element.id = uniqueID;

    if (element.tagName.toLowerCase() === 'input') {
      element.value = uniqueID;
    }

    //console.log("Element after:", element, "ID:", element.id, "Value:", element.value);
  });
}

// Automatically assign unique IDs on DOM load
document.addEventListener('DOMContentLoaded', function () {
  //console.log("DOM fully loaded. Assigning unique IDs...");
  generateUniqueIDs('.needs-unique-id');
});

// Add click event listener to all elements with .click-causes-regeneration to regenerate unique IDs
document.querySelectorAll('.click-causes-regeneration').forEach(element => {
  element.addEventListener('click', function () {
    //console.log("Regeneration triggered by click on:", element);
    generateUniqueIDs('.needs-unique-id');
  });
});

// Export function for accessibility elsewhere
window.generateUniqueIDs = generateUniqueIDs;

document.addEventListener('DOMContentLoaded', function () {
  // Function to unmute all video elements
  function unmuteAllVideos() {
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
      video.muted = false;
    });
  }

  // Select all buttons with the class 'unmute-all-videos'
  const unmuteButtons = document.querySelectorAll('.unmute-all-videos');

  // Attach event listeners to each button
  unmuteButtons.forEach(button => {
    button.addEventListener('click', function () {
      unmuteAllVideos();
    });
  });
});

// Make the watch demo buttons work
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('a.button.button--primary').forEach(button => {
        if (button.textContent.trim() === "Watch Demo") {
            button.addEventListener('click', function(event) {
                event.preventDefault(); // Prevent the default link behavior
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top
                //const mediaContainer = document.querySelector('.deferred-media__poster'); // Select the first match
                //if (mediaContainer) {
                    // Trigger a click on the media container
                //    mediaContainer.click(); 
                //}
            });
        }
    });
});

